if (!window.customElements.get('panel-content')) {

    class PanelContent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }
    
      init() {
        this.matchHeights();
      }

      matchHeights() {
        // Find the parent .shopify-section
        const parentSection = this.closest('.shopify-section');
        if (!parentSection) return;

        // Find all panel-content elements within the same section
        const panelContents = parentSection.querySelectorAll('panel-content');
        if (panelContents.length <= 1) return;

        // Reset heights to auto to get natural heights
        panelContents.forEach(panel => {
          panel.style.height = 'auto';
        });

        // Find the tallest panel-content
        let maxHeight = 0;
        panelContents.forEach(panel => {
          const height = panel.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        // Set all panel-content elements to the same height
        if (maxHeight > 0) {
          panelContents.forEach(panel => {
            panel.style.height = maxHeight + 'px';
          });
        }
      }

    }
    
    // Register the web component
    customElements.define('panel-content', PanelContent);
  
  }